import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { OtherOptionsStepView } from './OtherOptionsStepView';
import orderService from '../OrderService';
import { BaseTextBox } from '../../controls/BaseTextBox';
import { BaseCombobox } from '../../controls/BaseCombobox';
import { StepComboBoxGroup } from './StepComboBoxGroup';
import toLocalString from '../../infrastructure/DateTimeFunctions';

export class CustomizedMachineOtherStepView extends Component {
    static displayName = CustomizedMachineOtherStepView.name;
    constructor(props) {
        super(props);
        let data = orderService.getCurrentCustomizedMachineProductOptions();
        var selAttachment = '';
        if (props.model.attachment && props.model.attachment != -1) {
            selAttachment = props.model.attachment;
        } else {
            if (data && data.attachment && data.attachment.length > 0) {
                selAttachment = data.attachment[0].id;
            }
            
        }

        //if (data != null) {
        //    console.log(props.model);
        //    if (props.model.attachment && props.model.attachment != -1) {
        //        selAttachment = props.model.attachment;
        //    } else {
        //        selAttachment = data.attachment[0].id;
        //    }
        //    // console.log(selAttachment);
        //    //console.log(data.attachment[0]);
        //    //if (!selAttachment) {
        //    //    var attachmentItems = data.attachment;
        //    //    for (let i = 0; i < attachmentItems.length; i++) {                    
        //    //        var insioAx = orderService.getInsioAxOption();
        //    //        if (insioAx && attachmentItems[i].code == "21025145") {
        //    //            selAttachment = attachmentItems[i].id;
        //    //            this.setState({ attachment: selAttachment });
        //    //            break;
        //    //        }
        //    //       // console.log(attachmentItems);
        //    //        var biCoreCustomLi = orderService.getBiCoreCustomLiOption();
        //    //        if (biCoreCustomLi && attachmentItems[i].code == "21025146") {
        //    //            selAttachment = attachmentItems[i].id;
        //    //            this.setState({ attachment: selAttachment });
        //    //            break;
        //    //        }                    
        //    //    }
        //    //}            
        //}
        //console.log(props.model);
        this.state = {
            uploading: false, data: data,
            antiEarwaxDevice: props.model.antiEarwaxDevice, vent: props.model.vent, onlyForRICSeries: props.model.onlyForRICSeries,
            attachment: selAttachment, propertyChanged: false
        };
        // console.log(this.state);
        this.handleLeftChange = this.handleLeftChange.bind(this);
        this.handleRightChange = this.handleRightChange.bind(this);
        this.handleSelectChanged = this.handleSelectChanged.bind(this);
        this.handleAntiEarwaxDeviceChanged = this.handleAntiEarwaxDeviceChanged.bind(this);
        this.handleVentChanged = this.handleVentChanged.bind(this);
        this.handleOnlyForRICSeriesChanged = this.handleOnlyForRICSeriesChanged.bind(this);
        this.handleAttachmentChanged = this.handleAttachmentChanged.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

    }

    notifyPropertyChanged() {
        let propertyChanged = !this.state.propertyChanged;
        this.setState({ propertyChanged: propertyChanged });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        var model = this.props.orderModel;
        if (model) {
            switch (name) {
                case "fillingPerson":
                    model.fillingPerson = value;
                    break;
                case "contactDetails":
                    model.contactDetails = value;
                    break;
            }
            this.notifyPropertyChanged();
        }
    }

    handleAttachmentChanged(e) {
        if (this.state.data) {
            let attachment = e.target.value;
            this.setState({ attachment: attachment });
        }
    }

    handleOnlyForRICSeriesChanged(e) {
        if (this.state.data) {
            this.setState({ onlyForRICSeries: e });
        }
    }

    handleVentChanged(e) {
        if (this.state.data) {
            this.setState({ vent: e });
        }
    }
    handleAntiEarwaxDeviceChanged(e) {
        if (this.state.data) {
            this.setState({ antiEarwaxDevice: e });
        }
    }

    handleSelectChanged(e) {
        var handler = this.onSelectChanged;
        if (handler) {
            handler(e);
        }
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    orderCommitting() {
        const isReceiver = this.isReceiver(this.state.data);
        if (!isReceiver) {
            this.setState({ onlyForRICSeries: null }, () => {
                orderService.updateProductOptionsWithoutCustomizedMachine(this.state);
            })
        } else {
            orderService.updateProductOptionsWithoutCustomizedMachine(this.state);
        }
        this.otherOptionsRef && this.otherOptionsRef.orderCommitting();
    }

    validate() {
        var fillingPerson = this.props.orderModel.fillingPerson;
        if (!fillingPerson || (fillingPerson && fillingPerson.trim() == '')) {
            return { state: false, msg: "FillingPersonRequired" };
        }
        var contactDetails = this.props.orderModel.contactDetails;
        if (!contactDetails || (contactDetails && contactDetails.trim() == '')) {
            return { state: false, msg: "ContactDetailsRequired" };
        }

        return { state: true }
    }


    handleLeftChange(e) {
        let value = e.target.value;
        let name = e.target.name;

        if (name == 'leftEnclousureType') {
            this.setState({ leftEnclousureType: value });
        }
        else if (name == 'leftWireless') {
            this.setState({ leftWireless: value });
        }
        else if (name == 'leftLine') {
            this.setState({ leftLine: value });
        }
        else if (name == 'leftSpecsMatrix') {
            this.setState({ leftSpecsMatrix: value });
        }
        else if (name == 'leftEnclosureColor') {
            this.setState({ leftColor: value });
        }
    }

    handleRightChange(e) {
        let value = e.target.value;
        let name = e.target.name;

        if (name == 'rightEnclousureType') {
            this.setState({ rightEnclousureType: value });
        }
        else if (name == 'rightWireless') {
            this.setState({ rightWireless: value });
        }
        else if (name == 'rightLine') {
            this.setState({ rightLine: value });
        }
        else if (name == 'rightSpecsMatrix') {
            this.setState({ rightSpecsMatrix: value });
        }
        else if (name == 'rightEnclosureColor') {
            this.setState({ rightColor: value });
        }
    }

    getLines(enclosureId, wl) {
        let data = this.state.data;
        if (data) {
            var model = data.customizedMachineModel;
            var lines = new Array();
            for (let i = 0; i < model.length; i++) {
                if (model[i].enclosureType.id == enclosureId && wl == model[i].wireless) {
                    let id = model[i].line.id;
                    if (!this.contains(lines, id)) {
                        lines.push({ id: id, name: model[i].line.name });
                    }

                }
            }
            return lines;
        }

        return null;
    }

    getMatrix(enclosure, line, wl) {
        let data = this.state.data;
        if (data) {
            var model = data.customizedMachineModel;
            var matrixes = new Array();
            for (let i = 0; i < model.length; i++) {
                if (model[i].enclosureType.id == enclosure && model[i].line.id == line && wl == model[i].wireless) {
                    let id = model[i].specsMatrix.id;
                    if (!this.contains(matrixes, id)) {
                        matrixes.push({ id: id, name: model[i].specsMatrix.name });
                    }
                }
            }
            return matrixes;
        }

        return null;
    }

    contains(array, id) {
        var returnValue = false;
        for (let i = 0; i < array.length; i++) {
            if (array[i].id === id) {
                returnValue = true;
                break;
            }
        }

        return returnValue;
    }

    isReceiver = (data) => {
        var receivers = data.enclosureTypes.filter(x => x.name.indexOf("受话器") > -1);
        var customizedMachineModel = this.props.model.customizedMachineModel;
        var arr = customizedMachineModel.split(';');
        var leftEnclosureType = arr[0].split(',')[0];
        var rightEnclosureType = arr[1].split(',')[0];
        if (receivers.length > 0) {
            return receivers.filter(x => x.id == leftEnclosureType || x.id == rightEnclosureType).length > 0;
        }
        return false;
    }

    render() {
        //let antiEarwaxDeviceItems = null;
        //let ventItems = null;
        //let onlyForRICSeriesItems = null;
        let attachmentItems = [];
        let attachmentCode = '';
        let otherOptions = [];
        let cord = [];
        let shellCoating = [];
        let isReceiver = false;
        let data = this.state.data;

        let leftAntiEarwaxDeviceItems = [];
        let leftVentItems = [];
        let leftOnlyForRICSeriesItems = [];
        let rightAntiEarwaxDeviceItems = [];
        let rightVentItems = [];
        let rightOnlyForRICSeriesItems = [];

        // console.log(data);
        if (data) {
            leftAntiEarwaxDeviceItems = data.leftAntiEarwaxDevice;
            leftVentItems = data.leftVent;
            leftOnlyForRICSeriesItems = data.leftOnlyForRICSeries;
            rightAntiEarwaxDeviceItems = data.rightAntiEarwaxDevice;
            rightVentItems = data.rightVent;
            rightOnlyForRICSeriesItems = data.rightOnlyForRICSeries;

            //antiEarwaxDeviceItems = data.antiEarwaxDevice;
            //ventItems = data.vent;
            //onlyForRICSeriesItems = data.onlyForRICSeries;
            attachmentItems = data.attachment;
            otherOptions = data.otherOptions;
            cord = data.cord;
            shellCoating = data.shellCoating;

            for (let i = 0; i < attachmentItems.length; i++) {
                if (this.state.attachment) {
                    if (attachmentItems[i].id == this.state.attachment) {
                        attachmentCode = attachmentItems[i].code;
                        break;
                    }
                }
            }
            if (data.enclosureTypes) {
                isReceiver = this.isReceiver(data);
                /* var receivers = data.enclosureTypes.filter(x => x.name.indexOf("受话器") > -1);
                 var customizedMachineModel = this.props.model.customizedMachineModel;
                 var arr = customizedMachineModel.split(';');
                 var leftEnclosureType = arr[0].split(',')[0];
                 var rightEnclosureType = arr[1].split(',')[0];
                 if (receivers.length > 0) {
                     isReceiver = receivers.filter(x => x.id == leftEnclosureType || x.id == rightEnclosureType).length > 0;
                 }*/
            }
        }

        return (<div>
            <div className="flex gap-6">
                <div className="flex-grow">
                    <div className="border-b-2 border-blue-900 text-blue-800 mt-1 font-bold"><h2><FormattedMessage id="Attachment" /></h2></div>
                    <div className="mt-2 flex flex-col items-center">
                        <BaseCombobox classnames="" value={this.state.attachment ?? ""} onChange={this.handleAttachmentChanged}>
                            {/*<FormattedMessage id="CompanyDefault" >*/}
                            {/*    {text => <option value="-1">{text}</option>}*/}
                            {/*</FormattedMessage>*/}
                            {attachmentItems == null ? '' : attachmentItems.map((i, index) => <option key={index} value={i.id}>{i.name}</option>)}
                        </BaseCombobox>
                        <BaseTextBox classnames="mt-1" type="text" readOnly="readonly" value={attachmentCode} />
                    </div>
                    <div className="py-1 mt-4">
                        <div className="">
                            <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="FillingPerson" /><span className="font-bold text-red-600">*</span></label>
                            <BaseTextBox type="text" classnames="mt-1" value={this.props.orderModel.fillingPerson} name="fillingPerson" onChange={this.handleInputChange} />
                        </div>
                        <div className="mt-2">
                            <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="ContactDetails" /><span className="font-bold text-red-600">*</span></label>
                            <BaseTextBox type="text" classnames="mt-1" value={this.props.orderModel.contactDetails} name="contactDetails" onChange={this.handleInputChange} />
                        </div>
                        <div className="mt-2">
                            <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Date" /></label>
                            <BaseTextBox type="text" classnames="mt-1" value={this.props.orderModel.orderTime ? toLocalString(this.props.orderModel.orderTime, true) : ""} />
                        </div>
                    </div>
                </div>
                <div className="flex-grow flex flex-col justify-between">
                    <StepComboBoxGroup leftRightOption={this.props.leftRightOption} title="AntiEarwaxDevice" note="DefaultNote" items={leftAntiEarwaxDeviceItems} leftItems={leftAntiEarwaxDeviceItems} rightItems={rightAntiEarwaxDeviceItems} value={this.state.antiEarwaxDevice} onSelectValueChanged={this.handleAntiEarwaxDeviceChanged} />
                    <StepComboBoxGroup leftRightOption={this.props.leftRightOption} title="Vent" note="DefaultNote" items={leftVentItems} leftItems={leftVentItems} rightItems={rightVentItems} value={this.state.vent} onSelectValueChanged={this.handleVentChanged} />
                    <StepComboBoxGroup leftRightOption={this.props.leftRightOption} title="OnlyForRICSeries" items={leftOnlyForRICSeriesItems} leftItems={leftOnlyForRICSeriesItems} rightItems={rightOnlyForRICSeriesItems} value={isReceiver ? this.state.onlyForRICSeries : "-1;-1"} onSelectValueChanged={this.handleOnlyForRICSeriesChanged} />
                </div>
                <div className="flex-grow">
                    {otherOptions.length > 0 ? <OtherOptionsStepView isReceiver={isReceiver} leftRightOption={this.props.leftRightOption} otherOptions={otherOptions} otherOptionsValue={this.props.model.otherOptions}
                        cord={cord} cordValue={this.props.model.cord} shellCoating={shellCoating} shellCoatingValue={this.props.model.shellCoating} onRef={(ref) => { this.otherOptionsRef = ref }} /> : null}
                </div>
            </div>
            <div className="bg-red-50 text-red-800 mt-2 p-2">
                <h2 className="text-xs leading-4"><FormattedMessage id="OrderFillingInstructions" /></h2>
                <label className="leading-3"><FormattedMessage id="OrderFillingInstructionsContent" /></label>
                <div className="text-gray-500 text-xs italic leading-4">
                    <FormattedMessage id="OrderFillingInstructionsClaim" />
                </div>
            </div>
        </div>
        );
    }
}
